import { useSearchParams } from 'react-router-dom';
import useRequestQueryParams from '../../../../hooks/use-request-query-params';
import { DateTime } from 'luxon';
import { DateTimeQueryParams } from '../../../date-time-advanced/date-time-advanced';
import { noop } from 'lodash';

type DashboardQueryParams = DateTimeQueryParams & {
  hideActioned?: boolean;
  hideQuotes?: boolean;
  hideRequests?: boolean;
};

function extractDashboardSearchParams(params: URLSearchParams) {
  return {
    from: params.has('from') ? DateTime.fromISO(params.get('from')!) : undefined,
    to: params.has('to') ? DateTime.fromISO(params.get('to')!) : undefined,
    timeRange: params.has('timeRange') ? params.get('timeRange')! : 'today',
    hideActioned: params.has('hideActioned') ? params.get('hideActioned') === 'true' : false,
    hideQuotes: params.has('hideQuotes') ? params.get('hideQuotes') === 'true' : false,
    hideRequests: params.has('hideRequests') ? params.get('hideRequests') === 'true' : false,
  };
}

export const useDashboardQueryParams = () => {
  // List request hooks
  const [params] = useSearchParams();
  const { setRequest, request } = useRequestQueryParams<DashboardQueryParams>(
    extractDashboardSearchParams(params),
    noop,
    [],
  );

  return {
    setRequest,
    request,
  };
};
